import React, { useState } from 'react';
import Chatbot from '../../Chatbot';
import { IoChatbubbleEllipses } from "react-icons/io5";
import '../../common/Styles.css'

export const ChatbotChild = () => {
    const [chatOpen, setChatOpen] = useState(false);

    return (
        <div className="chatbot-container">
            <button
                name="chatbot-btn"
                onClick={() => setChatOpen(!chatOpen)}
                className='chatbot-container-btn'
                ><IoChatbubbleEllipses /></button>
            <Chatbot isOpen={chatOpen} onClose={() => setChatOpen(false)} />
        </div>
    )
}